import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface SectionProps {
  slide?: boolean
  spacing?: number
  children: any
}

const Section: React.FC<SectionProps> = ({ children, ...props }) => {
  return <Wrap {...props}>{children}</Wrap>
}

export default Section

const slide = css`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
`

const Wrap = styled.div<SectionProps>`
  position: relative;
  width: 100%;
  gap: ${(p) => (p.spacing ? p.spacing : 20)}px;

  ${(p) => p.slide && slide}
`
